import { app } from "../../../../../Frame/App";

export class ImageFunctions {

    /**
     * Allows an img-Tag to contain src-Attributes for multiple languages. This function evaluates the 
     * localized src-Attributes and only shows the appropriate image file for the current language.
     * 
     * Example: <img src="myDefaultImage.png" data-multilanguage-image src-de="mein deutsches bild.png" src-en="my englisch picture.png" />
     * 
     * If the current language is German, the img tag will be prcessed to this:
     * <img src="mein deutsches bild.png1" />
     * @param element
     */
    public static createMultiLanguageImages = (element: HTMLElement) => {
        let mliElements = element.querySelectorAll("[data-multilanguage-image]");

        mliElements.forEach(e => {

            let mliElement = e as HTMLElement;

            let langToSrcDict: { [lang: string]: string } = {};
            for (let lang of app.availableLanguages) {
                let attribute = "src-" + lang;
                let srcForLanguage = mliElement.getAttribute(attribute);

                if (srcForLanguage && srcForLanguage.length > 0) {
                    langToSrcDict[lang] = srcForLanguage;
                    mliElement.removeAttribute(attribute);
                }
            }

            let currentLanguageImage = langToSrcDict[app.language];

            if (currentLanguageImage) {
                if (currentLanguageImage.indexOf("~") > -1) {
                    currentLanguageImage = app.resolveUrl(currentLanguageImage);
                }
                mliElement.setAttribute("src", currentLanguageImage);
            }
        });
    }

}